import { render, staticRenderFns } from "./AdminShopProductEdit.vue?vue&type=template&id=5eaf1424&scoped=true&"
import script from "./AdminShopProductEdit.vue?vue&type=script&lang=js&"
export * from "./AdminShopProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopProductEdit.vue?vue&type=style&index=0&id=5eaf1424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf1424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eaf1424')) {
      api.createRecord('5eaf1424', component.options)
    } else {
      api.reload('5eaf1424', component.options)
    }
    module.hot.accept("./AdminShopProductEdit.vue?vue&type=template&id=5eaf1424&scoped=true&", function () {
      api.rerender('5eaf1424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminShopProductEdit.vue"
export default component.exports